import React from "react";

type WizardLayoutProps = {
  currentStep: number;
  totalSteps: number;
  children: React.ReactNode;
  stageClassName?: string;
};

const WizardLayout: React.FC<WizardLayoutProps> = ({
  currentStep,
  totalSteps,
  children,
  stageClassName = "",
}) => {
  const progressPct = (currentStep / totalSteps) * 100;

  return (
    <div className={`wizard-stage ${stageClassName}`.trim()}>
      <div className="wizard-progress" aria-hidden="true">
        <div className="wizard-progress-fill" style={{ width: `${progressPct}%` }} />
      </div>

      <div className="wizard-step-dots" aria-hidden="true" dir="ltr">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`wizard-step-dot${i < currentStep - 1 ? " done" : i === currentStep - 1 ? " active" : ""}`}
          />
        ))}
      </div>

      {children}
    </div>
  );
};

export default WizardLayout;
